module.exports = __webpack_public_path__ + "img/full-screen.2194f558.svg";